import React from 'react';
// import { useRecoilValue, useSetRecoilState, useRecoilState } from 'recoil';
import {
  // useLocation, useHistory,
  NavLink,
} from 'react-router-dom';
// import PropTypes from 'prop-types';
// import _isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
// import IconButton from '@material-ui/core/IconButton';
// import MenuIcon from '@material-ui/icons/Menu';
// import Slider from 'react-slick';
// import SearchIcon from '@material-ui/icons/Search';
// import Typography from '@material-ui/core/Typography';
// import Drawer from '@material-ui/core/Drawer';
// import ListItem from '@material-ui/core/ListItem';
// import ListItemText from '@material-ui/core/ListItemText';
// import List from '@material-ui/core/List';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
// import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
// import Divider from '@material-ui/core/Divider';
// import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
// import ChevronRightIcon from '@material-ui/icons/ChevronRight';
// import Hidden from '@material-ui/core/Hidden';
// import Button from '@material-ui/core/Button';
// import Menu from '@material-ui/core/Menu';
// import MenuItem from '@material-ui/core/MenuItem';
// import Badge from '@material-ui/core/Badge';
// import CloseIcon from '@material-ui/icons/Close';
// import FavoriteIcon from '@material-ui/icons/Favorite';
// import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
// import AccountCircleIcon from '@material-ui/icons/AccountCircle';
// import ExitToAppIcon from '@material-ui/icons/ExitToApp';
// import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
// import DashboardIcon from '@material-ui/icons/Dashboard';
// import NotificationsIcon from '@material-ui/icons/Notifications';
// import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core/styles';
// import { useKeycloak } from '@react-keycloak/web';

import FARE_LOGO from '../../assets/images/logo-fare.svg';
// import { httpRequest } from '../../utils';
// import { API } from '../../config';

import './AppHeader.scss';
// import {
//   getUtmEnabledLink,
//   utmSource,
//   UTM_CAMPAIGN,
//   UTM_MEDIUM,
// } from '../../helpers/utmHelper';
// import { notificationAlertState } from '../../state';

const drawerWidth = 270;

const useStyles = makeStyles((theme) => ({
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    color: '#1d4f91',
    backgroundColor: '#fff',
  },
  appBarShift: {
    // width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    // marginRight: theme.spacing(2),
    margin: '0 .5rem',
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    // flexShrink: 0,
    // height: '22rem',
  },
  drawerPaper: {
    width: drawerWidth,
    height: 'auto',
    // borderBottom: '1px solid rgb(0, 0, 0, 0.12)',
  },
  drawerHeaderMain: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'space-between',
  },
  listItemLink: {
    textDecoration: 'none',
    color: '#1d4f91',
    '&:hover': {
      textDecoration: 'none',
    },
    marginLeft: '8px',
    textTransform: 'none',
    '&:first-child': {
      marginLeft: 0,
    },
  },
  drawerlistItemLink: {
    textDecoration: 'none',
    color: 'rgba(0, 0, 0, 0.87)',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  menuWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '5px 0',
    maxWidth: '1200px',
    margin: '0 auto',
    width: '100%',
  },
  leftCol: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    '@media (max-width: 1199px)': {
      width: '100%',
    },
  },
  rightCol: {
    width: '90%',

    '@media (max-width: 1199px)': {
      width: '0',
    },
  },
  listItems: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  listItemBtn: {
    textDecoration: 'none',
    color: '#1d4f91',
    marginLeft: '8px',
    textTransform: 'none',
    fontSize: '16px',
    paddingTop: '10px',
    paddingBottom: '10px',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  listItemBtnIcon: {
    textDecoration: 'none',
    color: '#1d4f91',
    marginLeft: '8px',
    textTransform: 'none',
    fontSize: '16px',
    paddingTop: '12px',
    paddingBottom: '12px',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  menuPaper: {
    position: 'relative',
    zIndex: '999',
    marginTop: '.75rem',
    // marginLeft: '-3.9rem',
    // color: '#1d4f91',
    // width: '12rem',
    width: 'max-content',
  },
  selected: {
    '&$selected': {
      backgroundColor: 'unset',
      color: '#06a6b6',
      '&:hover': {
        color: 'none',
        backgroundColor: 'unset',
      },
    },
  },
  listRoot: {
    paddingBottom: '0',
  },
  listItemRoot: {
    padding: '1rem 1.2rem',
  },
  listItemIcon: {
    minWidth: '0',
    marginRight: '.5rem',
  },
  notificationMenuItem: {
    paddingRight: '1rem',
  },
  notificationViewMore: {
    textAlign: 'center',
    '& span': {
      padding: 0,
      fontSize: '0.9rem',
      color: theme.palette.primary.main,
    },
  },
}));

const AppHeader = () => {
  const classes = useStyles();
  // const theme = useTheme();
  // const location = useLocation();
  // const history = useHistory();
  // const { keycloak } = useKeycloak();

  // const setNotificationAlert = useSetRecoilState(notificationAlertState);

  // const [openDrawer, setOpenDrawer] = useState(false);
  // const [anchorEl, setAnchorEl] = useState({});
  // const [profileMenuAnchorEl, setProfileMenuAnchorEl] = useState(null);
  // const [notificationsMenuAnchorEl, setNotificationsMenuAnchorEl] =
  // useState(null);
  // const [drawerStatus, setDrawerStatus] = useState('Main');
  // const [activeSlide, setActiveSlide] = useState();

  // const handleDrawerOpen = () => {
  //   setOpenDrawer(true);
  // };

  // const handleDrawerClose = () => {
  //   setOpenDrawer(false);
  //   setDrawerStatus('Main');
  // };

  // const handleClick = (event, item) => {
  //   setAnchorEl((prev) => ({
  //     ...prev,
  //     [item]: event.currentTarget,
  //   }));
  // };

  // const handleClose = () => {
  //   setAnchorEl({});
  // };

  // const handleProfileMenuClick = (event) => {
  //   setProfileMenuAnchorEl(event.currentTarget);
  // };

  // const handleProfileMenuClose = () => {
  //   setProfileMenuAnchorEl(null);
  // };

  // const handleNotificationsMenuClick = (event) => {
  //   setNotificationsMenuAnchorEl(event.currentTarget);
  // };

  // const handleNotificationsMenuClose = () => {
  //   setNotificationsMenuAnchorEl(null);
  // };

  // const handleOpenMoreDrawer = (listName) => {
  //   setDrawerStatus(listName);
  // }
  // const handleOpenDrawer = (item) => {
  //   setDrawerStatus(item);
  // };
  // const handleOpenMainDrawer = () => {
  //   setDrawerStatus('Main');
  // };

  // const login = useCallback(() => {
  //   if (keycloak) {
  //     // keycloak.login();
  //     const url = keycloak.createLoginUrl();
  //     window.location.assign(url);
  //   }
  // }, [keycloak]);

  // useEffect(() => {
  //   const allSlides = document.querySelectorAll(
  //     '.navbar-container .notification-wrap > div',
  //   );
  //   allSlides.forEach((s) => {
  //     s.classList.remove('animate');
  //     s.style.setProperty('--scroll-indent', `0px`);
  //   });
  //   const currentSlideText = document.querySelector(
  //     '.navbar-container .slick-active .notification-wrap > div',
  //   );
  //   if (currentSlideText) {
  //     if (currentSlideText.scrollWidth > currentSlideText.clientWidth) {
  //       const widthDiff =
  //         currentSlideText.scrollWidth - currentSlideText.clientWidth;
  //       currentSlideText.classList.add('animate');
  //       currentSlideText.style.setProperty(
  //         '--scroll-indent',
  //         `-${widthDiff}px`,
  //       );
  //     }
  //   }
  // }, [activeSlide]);

  return (
    <div className="navbar-container">
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          // [classes.appBarShift]: openDrawer,
        })}
      >
        <Toolbar className={classes.menuWrap}>
          <div className={classes.leftCol}>
            <NavLink
              to={{ pathname: 'https://foodallergy.org' }}
              target="_blank"
              style={{ fontSize: 0, padding: '5px 15px' }}
            >
              <img
                src={FARE_LOGO}
                alt="FARE Logo"
                width={200}
                className="fare-logo"
              />
            </NavLink>
            {/* <div className="hamburger-menu">
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                className={clsx(classes.menuButton, openDrawer && classes.hide)}
              >
                <MenuIcon />
              </IconButton>
            </div> */}
          </div>
        </Toolbar>
      </AppBar>
      <Toolbar style={{ height: '80px' }} />
      {/* {notifications && notifications.length > 0 && <Toolbar variant="dense" />} */}
      {/* <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="right"
        open={openDrawer}
        classes={{
          root: classes.drawer,
          paper: classes.drawerPaper,
        }}
      >
        {drawerStatus === 'Main' ? (
          <div className={classes.drawerHeaderMain}>
            <IconButton onClick={handleDrawerClose}>
              <CloseIcon className="close-btn" />
            </IconButton>
          </div>
        ) : (
          <div className={classes.drawerHeader}>
            <Button
              onClick={handleOpenMainDrawer}
              style={{ padding: '0 0.75rem 0 0' }}
            >
              {theme.direction === 'ltr' ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <ChevronLeftIcon
                    style={{ color: '#06a6b6', fontSize: '2rem' }}
                  />
                  <p className="return-text">Back</p>
                </div>
              ) : (
                <ChevronRightIcon />
              )}
            </Button>
            <IconButton onClick={handleDrawerClose}>
              <CloseIcon className="close-btn" />
            </IconButton>
          </div>
        )}

        <Divider />
      </Drawer> */}
    </div>
  );
};

AppHeader.propTypes = {};

export default AppHeader;
